module.exports = __webpack_public_path__ + "static/media/foto4.ae25116b.png";